import {
  AdminSpinner,
  Box,
  Div,
  H3,
  H5,
  Icon,
  P,
  VerticalSeparator,
  centsToDollars,
  formatter,
  lightTheme,
} from '@vgrubs/components';
import { useState } from 'react';
import { IncomeDetailModal } from './DetailModals/IncomeDetailModal';
import { WithdrawalDetailModal } from './DetailModals/WithdrawalDetailModal';
import { IconIncome, IconWithdrawal } from './TransactonsStyled';
import { TransactionDateComponent } from './TransactionComponents';
import {
  NewTransactionResponse,
  vGrubsIncomeEntity,
  vGrubsWithdrawalEntity,
} from 'components/src/types/api/wallet.types';

export const TransactionsVGrubs = ({
  transactions,
  sumTransactions,
  type,
  setType,
  loadingSum,
  page,
}: {
  transactions: { date: string; items: NewTransactionResponse[] }[];
  sumTransactions: {
    vGrubsIncome: number;
    vGrubsWithdrawals: number;
    lastVGrubsIncome: number;
    lastVGrubsWithdrawal: number;
    userName: string;
  };
  type: string;
  setType: (type: string) => void;
  loadingSum: boolean;
  page: number;
}) => {
  const [incomeModal, setIncomeModal] =
    useState<NewTransactionResponse<vGrubsIncomeEntity> | null>(null);
  const [withdrawalModal, setWithdrawalModal] =
    useState<NewTransactionResponse<vGrubsWithdrawalEntity> | null>(null);

  return (
    <div>
      <Div $flex $columnSM $gap="20px" $gapSM="16px" $mb="24" $mbSM="16">
        <Box
          $flex
          $alignCenter
          $pointer
          $width="50%"
          $widthSM="100%"
          $box={type === 'Incomes'}
          $outlineBox={type !== 'Incomes'}
          onClick={() => setType('Incomes')}
          $relative
          $overflow="hidden"
        >
          {loadingSum && <AdminSpinner absolute small $noZIndex />}

          <Icon>
            <IconIncome />
          </Icon>
          <VerticalSeparator
            $m="0 20px"
            $mSM="0 16px"
            $h="40px"
            $color={lightTheme.lightGray}
          />
          <Div>
            <H5 $m="0">Total Income</H5>
            <H3
              $m="0"
              $color={
                sumTransactions?.vGrubsIncome < 0
                  ? lightTheme.primary
                  : sumTransactions?.vGrubsIncome === 0
                  ? lightTheme.darkGray
                  : lightTheme.green
              }
            >
              {formatter.format(centsToDollars(sumTransactions?.vGrubsIncome))}
            </H3>
            <P $m="0">
              Last Income:{' '}
              {formatter.format(
                centsToDollars(sumTransactions?.lastVGrubsIncome)
              ) || 0}
            </P>
          </Div>
        </Box>
        <Box
          $p="16px 24px"
          $flex
          $alignCenter
          $pointer
          $width="50%"
          $widthSM="100%"
          $box={type === 'Withdrawals'}
          $outlineBox={type !== 'Withdrawals'}
          onClick={() => setType('Withdrawals')}
          $relative
          $overflow="hidden"
        >
          {loadingSum && <AdminSpinner absolute small $noZIndex />}

          <Icon>
            <IconWithdrawal />
          </Icon>
          <VerticalSeparator
            $m="0 20px"
            $mSM="0 16px"
            $h="40px"
            $color={lightTheme.lightGray}
          />
          <Div>
            <H5 $m="0">Withdrawals</H5>
            <H3 $m="0">
              {' '}
              {formatter.format(
                centsToDollars(sumTransactions?.vGrubsWithdrawals)
              )}
            </H3>
            <P $m="0">
              Last Withdrawal:{' '}
              {formatter.format(
                centsToDollars(sumTransactions?.lastVGrubsWithdrawal)
              )}
            </P>
          </Div>
        </Box>
      </Div>
      {transactions?.map((item, i) => {
        return (
          <TransactionDateComponent
            key={item.date}
            index={i}
            item={item}
            setIncomeModal={setIncomeModal}
            setWithdrawalModal={setWithdrawalModal}
            page={page}
          />
        );
      })}
      <IncomeDetailModal
        modalIsOpen={incomeModal}
        closeModal={() => setIncomeModal(null)}
      />
      <WithdrawalDetailModal
        modalIsOpen={withdrawalModal}
        closeModal={() => setWithdrawalModal(null)}
      />
    </div>
  );
};
